import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogData } from 'src/app/core/model';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss'],
})
export class CommonDialogComponent {

  message: string = '';
  confirmButtonText: string = '';
  cancelButtonText: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _dialogRef: MatDialogRef<CommonDialogComponent>
  ) {
    this.message = data.message;
    this.confirmButtonText = data.buttonText.ok;
    this.cancelButtonText = data.buttonText.cancel;
  }

  /* Delete dialog close */
  save() {
    this._dialogRef.close(true);
  }
}
